import { createApi } from '@reduxjs/toolkit/query/react';

import type {
  ClaimGalaResponseSchemaType,
  GetClaimGalaResponseSchemaType,
  GetWalletSessionResponseSchemaType,
  WalletConnectRequestSchemaType,
  WalletSessionType,
} from '@/global/schemas/claimGala.schema';
import type { Address } from '@/global/types/common.type';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const claimGalaApi = createApi({
  reducerPath: REDUX_SLICE.CLAIM_GALA_API,
  tagTypes: ['WalletSessionsV1', 'WalletConnectV1', 'RequestPriceV1'],
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    fetchSessionV1: builder.query<WalletSessionType, { address: Address }>({
      query: ({ address }) => ({ path: `v1/wallets/${address}/sessions`, version: 'v1' }),
      transformResponse: (returnValue: GetWalletSessionResponseSchemaType) => returnValue.data,
      providesTags: (_result, _error) => [{ type: 'WalletSessionsV1' }],
    }),
    walletConnectV1: builder.mutation<WalletSessionType, WalletConnectRequestSchemaType & { wAddress: Address }>({
      query: ({ address, wAddress }) => ({
        method: 'POST',
        path: `v1/wallets/${wAddress}/connects`,
        data: { address },
        version: 'v1',
      }),
      transformResponse: (returnValue: GetWalletSessionResponseSchemaType) => {
        return returnValue.data ?? { isError: true, errorMessage: returnValue?.message };
      },
      invalidatesTags: (_result, _error) => [{ type: 'WalletConnectV1' }],
    }),
    claimGalaV1: builder.mutation<ClaimGalaResponseSchemaType, { wAddress: Address }>({
      query: ({ wAddress }) => ({
        method: 'POST',
        path: `v1/wallets/${wAddress}/connects/claim`,
        data: null,
        version: 'v1',
      }),
      transformResponse: (returnValue: GetClaimGalaResponseSchemaType) => returnValue.data,
      invalidatesTags: (_result, _error) => [{ type: 'WalletConnectV1' }],
    }),
  }),
});

export const { useFetchSessionV1Query, useWalletConnectV1Mutation, useClaimGalaV1Mutation } = claimGalaApi;
